import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import { Icon } from '../../components';
import ContentTable from './../shared/publish-content/content-table';

/**
 * Publisher portal dashboard view for publishers/system admins.
 */
const Dashboard = ({ getContent, deleteContent, contentResult, isFetchingContent, isFetching, contentDetailsRoute }) => (
  <div className='base-layout'>
    <section id='header--publishers' className='layout--header'>
      <Grid>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Welcome to Caddie for publishers</h1>
          </Col>
        </Row>
        <Row className='button-gutter'>
          <Col xs={12} md={6}>
            <h2>Reward your audience and drive more visits to your site</h2>
            <p>Caddie rewards your audience by giving them the ability to earn CPD for the content they are consuming online. Add your content here and we'll publish it in Caddie and automatically reward your audience. Add questions to your content, and we'll increase their reward. It's that easy!</p>
          </Col>
        </Row>
      </Grid>
    </section>
    <section id='section--publishers' className='layout--section'>
      <Grid>
        <section id='publishers--your-caddie-links' className='publishers--dashboard'>
          <Row className='xs-gutter mobile-boxed'>
            <Col xs={12} md={6}>
              <h2><Icon icon='caddie-links-large-alt' /> Your Content</h2>
              <p>Add or manage Content.</p>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer className='large full pull-down' to={routes.publisherPortal.contentDetails}>
                <Button>
                  <Icon icon='add-large' /> Add Content
                </Button>
              </LinkContainer>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer className='large full pull-down' to={routes.publisherPortal.content}>
                <Button>
                  See all Content <Icon icon='chevron-right-large' />
                </Button>
              </LinkContainer>
            </Col>
          </Row>
          <ContentTable
            contentResult={contentResult}
            isFetchingContent={isFetchingContent}
            isFetching={isFetching}
            contentDetailsRoute={contentDetailsRoute}
            getContent={getContent}
            deleteContent={deleteContent}
            contentPerPage={6} />
        </section>
      </Grid>
    </section>
  </div>
)

const mapStateToProps = (state) => ({
  contentResult: state.publisherPortal.content.contentResult,
  isFetchingContent: state.publisherPortal.content.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.publisherPortal.content.isFetching ||
    state.publisherPortal.content.isLoadingMore,
  contentDetailsRoute: routes.publisherPortal.contentDetails
});

const mapDispatchToProps = (dispatch) => ({
  getContent: bindActionCreators(publisherPortalActions.publisherPortal.content.get, dispatch),
  deleteContent: bindActionCreators(publisherPortalActions.publisherPortal.content.deleteContent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(Dashboard);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/dashboard.js